export default __webpack_public_path__ + "static/media/181.87679e79.png";